import React, { FC } from 'react';
import { useAppSelector } from 'src/app/hooks';
import { Role } from 'src/store/models/Auth';

import AdminHome from './AdminHome/AdminHome';
import ManufacturerHome from './ManufacturerHome/ManufacturerHome';
import ServiceHome from './ServiceHome/ServiceHome';

const Home: FC = () => {
  const user = useAppSelector((state) => state.auth.user);

  return user?.role === Role.SERVICE ? (
    <ServiceHome />
  ) : user.role === Role.MANUFACTURER ? (
    <ManufacturerHome />
  ) : (
    user.role === Role.ADMIN && <AdminHome />
  );
};

export default Home;
